module.exports = __webpack_public_path__ + "static/media/cash_payment.570ad7b2.svg";